import React from 'react';

const ThisCategoryTable = (props) => {
    return (
        <tr key={props.index} className="image" onClick={() => props.editData(props.item)}>
            <td>
                {props.item.name}
            </td>
        </tr>
    );
};

export default ThisCategoryTable;